import {
  isCarvanaNativeApp,
  isAndroidNativeWebview as isAndroidNativeWebviewFn
} from '../is-native-app';
import { MobileWebviewEvents } from '../mobile-webview-events';
import sendNativeEvent from '../send-native-event';
import type { NativeEventSource } from '../send-native-event';

// Check for native message handler OR user agent detection
export const isNativeWebview = !!(window.nativeWebViewMessageHandler ?? isCarvanaNativeApp());

export const isAndroidNativeWebview = isNativeWebview && isAndroidNativeWebviewFn();

export const enterNativeFullscreen = (source: NativeEventSource) => {
  if (isNativeWebview) {
    sendNativeEvent({
      event: MobileWebviewEvents.ENTER_FULLSCREEN,
      payload: {},
      source
    });
  }
};

export const leaveNativeFullscreen = (source: NativeEventSource) => {
  if (isNativeWebview) {
    sendNativeEvent({
      event: MobileWebviewEvents.LEAVE_FULLSCREEN,
      payload: {},
      source
    });
  }
};

// WKWebView does not auto-open `tel:` navigations, so a `tel:` anchor is a dead tap in-app and
// native has to place the call. Gates on the bridge rather than the user agent: what matters is
// whether a handler took the message, so a caller only `preventDefault()`s on a real handoff and
// otherwise leaves its own `tel:` href to handle the call.
export const contactAgentNatively = (phone: string, source: NativeEventSource) =>
  sendNativeEvent({
    event: MobileWebviewEvents.CONTACT_AGENT,
    payload: { phone },
    source
  });
